import * as docketPropTypes from "../docketPropTypes";
import { useEffect } from "react";

function logPageChange() {
	if (typeof ga !== "undefined") {
		ga("send", "pageview");
	}
}

export default function GoogleAnalytics({ location }) {
	const pathname = location.pathname;

	useEffect(() => {
		logPageChange();
	}, [pathname]);

	return null;
}

GoogleAnalytics.propTypes = {
	location: docketPropTypes.routerLocation.isRequired,
};
